import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { Assistancesale } from 'src/app/models/assistancesale';
import { MessageService } from 'primeng/api';
import { CancellationReason } from 'src/app/models/cancellation-reason';
import { TemporalTransaction, TEMPORAL_TRANSACTION_STATUSES, TEMPORAL_TRANSACTION_STATUSES_TEXT } from 'src/app/models/temporal-transaction';
import { IamService } from 'src/app/services/iam.service';
import { SponsorService } from 'src/app/services/sponsor.service';
import { LoaderService } from 'src/app/api/loader.service';
import { MeService } from 'src/app/services/me.service';
@Component({
    selector: 'app-create-temporal-transaction',
    templateUrl: './create-temporal-transaction.component.html',
    styleUrls: ['./create-temporal-transaction.component.css'],
    providers: [MessageService],
    standalone: false
})
export class CreateTemporalTransactionComponent implements OnInit, OnChanges {
  @Output() done = new EventEmitter();

  original?: TemporalTransaction = null;
  edited: TemporalTransaction;
  countries: Promise<any>;
  sponsors: [];
  assistances: [];
  frontings: Promise<any>;
  campaigns:any = [];
  datehoy:string;
  iAm = null;
  inputFocused = new EventEmitter<boolean>();
  @Output() update = new EventEmitter<TemporalTransaction>();
  @Output() cancelEvent = new EventEmitter();
  stopLightNumber:number;
  statuses = [
    {id: 1, name: 'Active'},
    {id: 3, name: 'Pending'},
  ];

  sale: Assistancesale;
  cancellationReasons: CancellationReason[];
  transactionStatus;
  transactionStatusText;
  isDisabled: boolean;
  canceledDate;
  retentionDate;
  operation_name;
  operation_reason;
  retentionComment;

  KitDate;
  kitComment;

  modificationDate;
  modificationComment;
  subtypes:any
  typologies:any


  subtypologies:any;
  subtypologiescancellation:any;

  cadenacountry : null;
  cadenasponsor : null;
  cadenaproduct: null;
  cadenachannel:null;
  // @Input()
  // set assistance(assistance: Assistance) {
  //   this.edited = Object.assign({}, assistance);
  //   if (assistance && assistance.country_id) {
  //     this.sponsors = this.api.sponsors.get(assistance.country_id)
  //       .filter({status: this.sponsorSvc.STATUS_ACTIVE})
  //       .promise();
  //     this.frontings = this.api.fronting.get(assistance.country_id).promise();
  //   }
  // }
  @Input() disabled: EventEmitter<boolean>;

  constructor(
    private api: ApiService, private iam: IamService, 
    private sponsorSvc: SponsorService,private loaderService: LoaderService,    private me: MeService,    public messageService: MessageService) {
    this.edited = new TemporalTransaction();
    this.edited.creation_date = new Date().toISOString().slice(0, 10);
    this.datehoy=new Date().toISOString().slice(0, 10);
    this.iAm = this.iam.isRole;

    this.transactionStatus = TEMPORAL_TRANSACTION_STATUSES;
    this.transactionStatusText = TEMPORAL_TRANSACTION_STATUSES_TEXT;
  }

  ngOnInit() {
    this.edited.user_id  = this.me.user.id;
    this.edited.username = this.me.user.email;
    this.loaderService.display(true);
    this.stopLightNumber = 30;
    this.edited.priority = 30;
    this.edited.creation_date = new Date().toISOString().slice(0, 10);
    this.edited.customer_name = "PEDRO"
    
    if (this.disabled) {
      this.disabled.subscribe(disabled => {
        this.isDisabled = disabled;
      });
    }
    this.countries = this.api.countries.get().all().promise()
      .then(c => c.data);

    this.loaddata();

  }

  async loaddata() {
  await  this.api.assistancesales.get_subtype().promise()
    .then((resp) => {
      this.subtypes = resp
      
    });
  
   await this.api.typologies.get().promise().then((resp)=>{
      this.typologies = resp.data;
      
    })

    this.loaderService.display(false);
  }

  ngOnChanges(changes: any) {
    this.inputFocused.emit(true);
  }

  async onSelectCountry(country_id) {
//
 // 
  let id=country_id.split("_")[0]
  this.edited.country_id = id
  this.edited.country_name = country_id.split("_")[1]
  this.edited.sponsor_id = null;
  this.edited.sponsor_name = null;

  this.cadenasponsor = null;
  this.cadenaproduct = null;

    this.loaderService.display(true);
    this.sponsors = [];
    this.assistances = [];

    
    await this.api.sponsors.get(id)
    .filter({status: this.sponsorSvc.STATUS_ACTIVE})
    .promise().then(data=>{
      this.sponsors = data;
      
      this.loaderService.display(false);
    }).catch(e =>{
      
      this.loaderService.display(false);
    });

    //this.frontings = this.api.fronting.get(id).promise();
  }

  async onSelectSponsor(sponsor_id){

   // 
    let id=sponsor_id.split("_")[0]
    this.edited.sponsor_id = id
    this.edited.sponsor_name = sponsor_id.split("_")[1]

    this.edited.product_id = null;
    this.edited.product_name = null;
    this.cadenaproduct = null;

    this.loaderService.display(true);
    this.assistances = [];
     this.api.assistances.get_by_sponsor(id)
    .promise().then(data=> {
      this.assistances = data;
      this.loaderService.display(false);
    }
 
      ).catch( e=> {
        
        this.loaderService.display(false);
      }
        
      );
  
  }

  onSelectProductponsor(product_id){

    //
    let id=product_id.split("_")[0]
    this.edited.product_id = id
    this.edited.product_name = product_id.split("_")[1]
  
  }

  onSelectChannel(channel_id){

    //
    let id=channel_id.split("_")[0]
    this.edited.sales_channel_id = id
    this.edited.sales_channel_name = channel_id.split("_")[1]
  
  }
  
  onSubmit() {
    // this.isDisabled = true;
    // this.update.emit(this.edited);
    //
    this.messageService.clear()
    this.loaderService.display(true);
    this.api.temporal_transaction_k2.create(this.edited)
    .post()
    .promise()
    .then(data => {
      this.loaderService.display(false);
      //
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: `Transacción Temporal registrada correctamente`,
      });
      this.done.emit(true);
    })
    .catch(e => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Ocurrio un error al registrar la Transacción Temporal`,
      });
      this.loaderService.display(false);
    })
  }

  onCancel() {
    this.cancelEvent.emit();
  }
  setRed() {
    this.stopLightNumber = 30;
    this.edited.priority = 30;
   
}
setYellow() {
    this.stopLightNumber = 20;
    this.edited.priority = 20;
}
setGreen() {
    this.stopLightNumber = 10;
    this.edited.priority = 10;
}

  getclass1(n){
    if(n==this.stopLightNumber){
        return 'btn btn-danger ml-2 bold'
    }
    else{
        return "btn btn-outline-danger ml-2"
    }
}
getclass2(n){
    if(n==this.stopLightNumber){
       
        return 'btn btn-warning ml-2 bold'
    }
    else{
        return "btn btn-outline-warning ml-2"
    }
}
getclass3(n){
    if(n==this.stopLightNumber){
       
        return 'btn btn-success ml-2 bold'
    }
    else{
        return "btn btn-outline-success ml-2"
    }
}




//---para lo de cancelacion
getCancellationReasons(sponsor_id) {
  this.cancellationReasons = [];
  //
  if (sponsor_id) {
    //
    this.api.sponsor.getCancellationReasons(sponsor_id).promise()
      .then((resp) => {
        
        this.cancellationReasons = resp.data;
        this.sale.cancellation_reason = this.cancellationReasons[0].description;
      });
  }
}

setCancellationReasons(status) {
  if (status === this.transactionStatus.CANCELED) {
    // Get cancellation reasons for sponsor
    if (this.sale.plan && this.sale.plan.product) {
      this.getCancellationReasons(this.sale.plan.product.sponsor_id);
    }
  }
}

onSelectStatus(status) {
  this.edited.type_management = status;
  this.edited.subtype2_management = null;
  this.edited.subtype2_management_name = null;
  this.edited.subtype_management = null; // limpio subtipologia y subtipologia 2
  this.edited.subtype_management_name = null;

  //
  if(status==3){ //---cancelado
    let cancelaciones = this.typologies.filter(element=>  element.description=="Cancelación")
    this.subtypologies= cancelaciones[0].typologies;
    this.edited.type_management_name = "Cancelación";
  } else if(status==4){ //--RETENCION
    let retenciones = this.typologies.filter(element=>  element.description=="Retención")
    this.subtypologies= retenciones[0].typologies[0].subtypologies;
    this.edited.type_management_name = "Retención";
  }

  else if(status==5){ //--modificacion
    let retenciones = this.typologies.filter(element=>  element.description=="Modificaciones")
    this.subtypologies= retenciones[0].typologies;
    this.edited.type_management_name = "Modificación";
  } else if(status==6) {
    this.subtypologies =[];
    this.edited.type_management_name = "Envio de Kit"
  }
  
  //this.setCancellationReasons(status);
}

//---CUANDO SE HACE CLICK AL COMBO DE SUBTIPOLOGIA Y TIPOLOGIA ES CANCELACION
onSelectCancellationtype(id){
  let cancelaciones = this.typologies.filter(element=>  element.description=="Cancelación")
  let subtipologia = cancelaciones[0].typologies.filter(element=>  element.id==id);

//---SETEO EL NOMBRE DE LA SUBTIPOLOGIA
//
  this.edited.subtype_management_name = subtipologia[0].description;
 // 

  //----obtengo las subtipologias de la subtipologia seleccionada
  let subtypescancelaciones = subtipologia[0].subtypologies;
  //
  this.subtypologiescancellation = subtypescancelaciones
}


onSelectCancellationsubtype(id){

  let cancelacion = this.subtypologiescancellation.filter(element=>  element.id==id);
  this.edited.subtype2_management_name = cancelacion[0].description;
 // 
}

onSelectsubtypology(id){

  let subtipologia = this.subtypologies.filter(element=>  element.id==id);
  this.edited.subtype_management_name = subtipologia[0].description
  // 
 // 
}



}
